import { Api } from "./Api";
import axios from "axios";
require('dotenv');

let SupervisorApi = {

    endpoint : "Supervisors/",

    async add(item) {
        delete item.id;

        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;
        const response = await axios.post(URL, item, { withCredentials: true });
        return response;
    },

    async update(item) {

        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + item.id;

        const response = await axios.put(URL, item, { withCredentials: true });
        return response;
    }
}

//Add the Api Mixin
SupervisorApi = Object.assign({}, Api, SupervisorApi);

export { SupervisorApi };
